import { patch } from "@rails/request.js";

/**
 * Toggle the activated (hidden) state of a project.
 * @param siteSlug - The slug of the site.
 * @param projectId - The ID of the project.
 * @param activated - Whether the project should be activated (visible).
 * @returns The JSON response from the server.
 */
export async function updateProjectMonitoring(siteSlug: string, projectId: number | string, activated: boolean) {
  const response = await patch(`/sites/${siteSlug}/projects/${projectId}/monitoring.json`, {
    body: JSON.stringify({ activated }),
    contentType: "application/json",
    responseKind: "json"
  });
  return await response.json;
}
